<template>
  <div class="gallery-section__slide">
    <div class="gallery-section__slide-img-wrapper feedback">
      <img :src="require('@/assets/img/feedbacks/feedback-' + index + '-1.png')" alt="feedback" />
      <img :src="require('@/assets/img/feedbacks/feedback-' + index + '-2.png')" alt="feedback" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeedbackSlide',
  props: {
    slide: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
};
</script>
